import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { dayjs } from '../../utils/date';
import { ITimeSelectorProps } from './TimeSelector.types';

export default function TimeSelector({
  onChange,
  defaultValue,
  value,
  ...props
}: ITimeSelectorProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        views={['hours']}
        timeSteps={{ hours: 1, minutes: 60, seconds: 60 }}
        sx={{ width: '100%', height: '100%' }}
        ampmInClock={false}
        ampm={true}
        slotProps={{ textField: { size: 'small' } }}
        value={dayjs(value)}
        onChange={(value) => {
          onChange?.(value ? dayjs(value).toISOString() : '');
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}
